import { PropsWithChildren } from 'react';
import { TextLabel } from '../TextLabel';
import {
	StyledContainer,
	StyledWrapper,
	StyledHeadingContainer,
	StyledBottomContainer,
	StyledPrint,
} from './Card.styled';

const Card = ({
	children,
	isEntering,
	isExiting,
	isVisible,
	isHidden,
	name,
	docNumber,
	vinNumber,
}: PropsWithChildren & {
	isEntering: boolean;
	isExiting: boolean;
	isVisible: boolean;
	isHidden: boolean;
	name?: string;
	docNumber?: string;
	vinNumber?: string;
}) => {
	return (
		<StyledWrapper
			$isEntering={isEntering}
			$isExiting={isExiting}
			$isVisible={isVisible}
			$isHidden={isHidden}
		>
			<StyledContainer>
				<StyledPrint />
				<StyledHeadingContainer>
					<TextLabel $size={14} $fw={700} $color={'rgba(0, 0, 0, 0.5)'}>
						ИНФОРМАЦИЯ О ТРАНСПОРТЕ
					</TextLabel>
					<TextLabel $size={14} $fw={700} style={{ height: 16 }}>
						{name}
					</TextLabel>
				</StyledHeadingContainer>
				{children}
				<StyledBottomContainer>
					<TextLabel $size={14} $fw={700} $color={'rgba(0, 0, 0, 0.5)'}>
						VIN: {vinNumber}
					</TextLabel>
					<TextLabel $size={14} $fw={700}>
						№ {docNumber?.replace(/(\d{3})(?=\d)/g, '$1 ')}
					</TextLabel>
				</StyledBottomContainer>
			</StyledContainer>
		</StyledWrapper>
	);
};

export { Card };
